var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 11.4583V1.54167H1.54167V11.4583H11.4583ZM11.4583 0.125C11.8341 0.125 12.1944 0.274255 12.4601 0.539932C12.7257 0.805609 12.875 1.16594 12.875 1.54167V11.4583C12.875 11.8341 12.7257 12.1944 12.4601 12.4601C12.1944 12.7257 11.8341 12.875 11.4583 12.875H1.54167C1.16594 12.875 0.805609 12.7257 0.539932 12.4601C0.274255 12.1944 0.125 11.8341 0.125 11.4583V1.54167C0.125 1.16594 0.274255 0.805609 0.539932 0.539932C0.805609 0.274255 1.16594 0.125 1.54167 0.125H11.4583ZM10.0417 5.79167V7.20833H2.95833V5.79167H10.0417Z",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMinusIcon);
export default __webpack_public_path__ + "static/media/square-minus-icon.e5455580a8187841b6109e1a3f5819cc.svg";
export { ForwardRef as ReactComponent };